/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Slider_HeadingInputs */

const en_app_slider_heading = /** @type {(inputs: App_Slider_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How the app works`)
};

const es_app_slider_heading = /** @type {(inputs: App_Slider_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo funciona la app`)
};

/**
* | output |
* | --- |
* | "How the app works" |
*
* @param {App_Slider_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const app_slider_heading = /** @type {((inputs?: App_Slider_HeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Slider_HeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_app_slider_heading(inputs)
	return en_app_slider_heading(inputs)
});